import { IconProps } from '@app/components/simple/ui-sprite';
import {
    RoundHollowedIcon,
    UiSpriteId
} from '@app/components/styled/icons/round-hollowed-icon';

export const ShoppingBagIcon = (props: Omit<IconProps, 'svgId'>) =>
    RoundHollowedIcon({ ...props, svgId: UiSpriteId.ShoppingBag });
